var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2265 6.7399C12.2185 6.7399 12.2105 6.73993 12.2025 6.74005C12.2043 6.69334 12.2052 6.64655 12.2052 6.59973C12.2052 4.79872 10.8797 3.3335 9.25057 3.3335C8.59571 3.3335 7.97533 3.56551 7.45643 4.00447C7.0953 4.31 6.80157 4.70734 6.60073 5.15523C6.26165 4.95088 5.8796 4.84186 5.48707 4.84186C4.20289 4.84186 3.15813 5.99681 3.15813 7.41644C3.15813 7.44739 3.15862 7.47831 3.15962 7.5092C2.13911 7.59836 1.33325 8.54494 1.33325 9.6957C1.33325 10.9051 2.2233 11.8891 3.31733 11.8891H12.2265C13.5107 11.8891 14.5555 10.7341 14.5555 9.31446C14.5555 7.89486 13.5107 6.7399 12.2265 6.7399Z",
    fill: "url(#paint0_linear_14_12335)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_14_12335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0044 7.51773C12.9963 7.51773 12.9883 7.51776 12.9803 7.51788C12.9821 7.47117 12.983 7.42438 12.983 7.37756C12.983 5.57655 11.6576 4.11133 10.0284 4.11133C9.37354 4.11133 8.75316 4.34334 8.23426 4.7823C7.87313 5.08783 7.5794 5.48517 7.37856 5.93306C7.03949 5.72871 6.65744 5.61969 6.2649 5.61969C4.98072 5.61969 3.93596 6.77465 3.93596 8.19428C3.93596 8.22522 3.93645 8.25614 3.93746 8.28703C2.91694 8.37619 2.11108 9.32277 2.11108 10.4735C2.11108 11.683 3.00113 12.6669 4.09517 12.6669H13.0044C14.2885 12.6669 15.3333 11.5119 15.3333 10.0923C15.3333 8.67269 14.2885 7.51773 13.0044 7.51773Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_14_12335",
    x: 0.211084,
    y: 2.21133,
    width: 17.0222,
    height: 12.3557,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14_12335"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14_12335",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_12335",
    x1: 15.6573,
    y1: 3.3335,
    x2: 12.77,
    y2: 14.7751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFD3F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BA6D0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.99f366467104599dcde4cca481f35950.svg";
export { ForwardRef as ReactComponent };